import React, { useRef, useState } from "react";
import api from "../../../../api/api";
import { CONSTANT_REDIRECT_TIME } from "../../../../constant/common";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const AddPracticeReviews = ({
    item,
    getPracticeDetails
}) => {

    const [otp, setOtp] = useState(new Array(6).fill(""));

    const inputRefs = useRef([]);

    const [isOTP, setIsOTP] = useState(false);

    const [formData, setFormData] = useState({
        fk_practices_id: item?.practices_id,
        name: null,
        email: null,
        message: null,
        rate: 0,
        accept_term: false
    })

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleStarClick = (rating) => {
        setFormData({ ...formData, rate: rating });
    };

    const handleSendOTP = async (e) => {
        e.preventDefault();

        if (formData.email === null || formData.email === "") {
            toast.error("Please enter the email");
            return;
        }
        
        if (formData.name === null || formData.name === "") {
            toast.error("Please enter the name");
            return;
        }
        
        if (formData.message === null || formData.message === "") {
            toast.error("Please enter the message");
            return;
        }

        const email = formData.email?.trim();

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            toast.error("Please enter a valid email address");
            return;
        }
        
        if (formData.rate === 0) {
            toast.error("Please select the rating");
            return;
        }

        if (!formData.accept_term) {
            toast.error("Please accept the Terms & Conditions and Privacy Policy");
            return;
        }

        const payload = {
            email: formData?.email
        }

        try {
            const response = await api.post("otp-send-reviews", payload);

            if (response?.data?.status === true) {
                // toast.success(response.data?.message);
                setIsOTP(true);

            } else {
                toast.error(response?.data?.message || "Failed ");
                return null;
            }
        } catch (error) {
            console.error("Error :", error);
            toast.error("Something went wrong. Please try again.");
            return null;
        }
    }

    const handleOTPChange = (index, e) => {
        const value = e.target.value;

        if (!/^\d*$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value.substring(value.length - 1);
        setOtp(newOtp);

        if (value && index < otp.length - 1) {
            inputRefs.current[index + 1].focus();
        }

        if (newOtp.every((digit) => digit !== "")) {
        }
    };

    const handleOTPKeyDown = (index, e) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const enteredOtp = otp.join("").trim();
        if (enteredOtp.length !== 6) {
            toast.error("Please enter the 6-digit OTP");
            return;
        }

        const payload = {
            ...formData,
            otp: enteredOtp
        }

        try {
            const response = await api.post("add-reviews", payload);

            if (response?.data?.status === true) {
                toast.success(response.data?.message);

                setFormData({
                    ...formData,
                    name: "",
                    email: "",
                    message: "",
                    rate: 0
                });

                setOtp(new Array(6).fill(""));

                setIsOTP(false);

                setTimeout(() => {
                    if (getPracticeDetails) {
                        getPracticeDetails();
                    }
                }, CONSTANT_REDIRECT_TIME);

            } else {
                toast.error(response?.data?.message || "Failed ");
                return null;
            }
        } catch (error) {
            console.error("Error :", error);
            toast.error("Something went wrong. Please try again.");
            return null;
        }
    }

    return (
        <>

            <form className="max-w-[520px]">
                <h2 className="text-2xl text-dark font-semibold mb-4">Rate your experience!</h2>
                <div className="flex gap-3 mb-12" id="reviewStars">
                    {[1, 2, 3, 4, 5].map((star) => (
                        <img
                            key={star}
                            src={formData.rate >= star ? "/assets/image/star.svg" : "/assets/image/balnkstar.svg"}
                            alt={`Star ${star}`}
                            className="w-8 h-8 cursor-pointer"
                            onClick={() => handleStarClick(star)}
                        />
                    ))}
                </div>
                <div className="mb-3">
                    <label for="name" className="mb-2 inline-block text-dark font-semibold text-xl">Your name</label>
                    <input
                        value={formData.name}
                        onChange={handleChange}
                        required
                        type="text" name="name" id="name" className="border-[1.2px] border-[#c2c2c2] w-full h-12 sm:h-14 rounded-xl px-4 sm:px-7 focus:border-blue outline-none text-lg sm:text-xl" placeholder="Enter your name" />
                </div>
                <div className="mb-3">
                    <label for="Email" className="mb-2 inline-block text-dark font-semibold text-xl">Email</label>
                    <input
                        value={formData.email}
                        onChange={handleChange}
                        required type="email" name="email" id="Email" className="border-[1.2px] border-[#c2c2c2] w-full h-12 sm:h-14 rounded-xl px-4 sm:px-7 focus:border-blue outline-none text-lg sm:text-xl" placeholder="Enter your email" />
                </div>
                <div className="mb-3">
                    <label for="message" className="mb-2 inline-block text-dark font-semibold text-xl">Please rate your experience on a 5-star scale.</label>
                    <textarea
                        onChange={handleChange}
                        name="message" id="message"
                        required
                        value={formData.message}
                        placeholder="Any comment for us?" className="border-[1.2px] border-[#c2c2c2] w-full h-12 sm:h-14 md:h-[70px] rounded-xl px-4 sm:px-7 focus:border-blue outline-none text-lg sm:text-xl  py-4 min-h-36">
                    </textarea>
                </div>
                <div className="mb-3">
                    <div className="flex items-start sm:items-center my-2">
                        <input required id="default-checkbox" type="checkbox"
                            name="accept_term"
                            checked={formData.accept_term}
                            onChange={(e) =>
                                setFormData({ ...formData, accept_term: e.target.checked })
                            } className="w-4 sm:w-6 h-5 sm:h-6 text-blue-600 bg-gray-100 border-gray-300 rounded  dark:bg-gray-700 dark:border-gray-600" />
                        <label htmlFor="default-checkbox" className="ms-2 text-base sm:text-xl font-medium text-dark w-[calc(100%-20px)]">I accept the <Link to="/terms-conditions" target="_blank" className="text-blue font-semibold">Terms &amp; Conditions</Link> and <Link to="/privacy-policy" target="_blank"  className="text-blue font-semibold">Privacy Policy</Link></label>
                    </div>
                </div>
                <button type="button"
                    onClick={handleSendOTP}
                    className="h-auto block py-3 px-3 sm:h-14 bg-blue w-full text-center text-white font-semibold text-lg sm:text-2xl rounded-xl  mb-5 sm:mb-[30px]">Submit</button>
            </form>

            <div id="emailModal" class={`fixed z-[999] inset-0 items-center justify-center bg-black bg-opacity-50 px-3 ${isOTP ? 'flex' : 'hidden'}`}>
                <div className="max-w-[850px] w-full rounded-[18px] bg-white sm:px-14 px-5 py-10 relative">
                    <button type="button"
                        onClick={(e) => {
                            setIsOTP(false);
                            setOtp(new Array(6).fill(""))
                        }}
                    className="absolute right-4 top-4">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.41791 0.436139C0.685579 0.168311 1.04857 0.0178675 1.42704 0.0178675C1.80551 0.0178675 2.1685 0.168311 2.43617 0.436139L9.99103 7.99754L17.5459 0.436139C17.6777 0.299682 17.8351 0.190853 18.0092 0.115982C18.1834 0.0411107 18.3708 0.00171073 18.5602 5.3593e-05C18.7497 -0.00158926 18.9377 0.0345535 19.1131 0.106382C19.2886 0.17821 19.4479 0.284296 19.5819 0.418424C19.7159 0.552553 19.822 0.712052 19.8938 0.887623C19.9654 1.06319 20.0015 1.25131 19.9999 1.44099C19.9982 1.63068 19.9588 1.81814 19.884 1.99242C19.8093 2.16671 19.7005 2.32435 19.5642 2.45612L12.0093 10.0175L19.5642 17.5789C19.8242 17.8484 19.9681 18.2092 19.9648 18.5838C19.9616 18.9584 19.8115 19.3167 19.5468 19.5815C19.2821 19.8464 18.9242 19.9967 18.5499 19.9999C18.1757 20.0032 17.8151 19.8592 17.5459 19.5989L9.99103 12.0375L2.43617 19.5989C2.16697 19.8592 1.80643 20.0032 1.43218 19.9999C1.05793 19.9967 0.699938 19.8464 0.435296 19.5815C0.170653 19.3167 0.0205397 18.9584 0.0172997 18.5838C0.0140454 18.2092 0.157906 17.8484 0.41791 17.5789L7.97277 10.0175L0.41791 2.45612C0.150327 2.18824 0 1.82494 0 1.44612C0 1.06732 0.150327 0.704024 0.41791 0.436139Z" fill="black"></path></svg>
                    </button>
                    <p className="text-dark text-xl text-center mb-6">Please confirm your email by entering the code that has been sent to your email address <a href="#" className="font-semibold text-blue">{formData?.email}</a></p>
                    <p className="text-dark text-xl text-center mb-6 md:mb-6">If you do not receive this email within a few minutes,
                        kindly check your spam or junk folder.</p>
                    <h1 className="text-dark text-center text-[24px] sm:text-[30px] leading-normal font-semibold mb-5 ">Kindly enter the email verification code</h1>
                    <div id="otp-form">
                        <div className="flex items-center justify-center gap-2 sm:gap-3">
                            {otp.map((value, index) => (
                                <input
                                    required
                                    key={index}
                                    value={value}
                                    ref={(el) => (inputRefs.current[index] = el)}
                                    onChange={(e) => handleOTPChange(index, e)}
                                    onKeyDown={(e) => handleOTPKeyDown(index, e)}
                                    type="text"
                                    className="w-[40px] h-[40px] sm:w-[56px] sm:h-[56px] text-center text-dark border-[1.2px] border-dark rounded p-2 sm:p-4 outline-none text-lg"
                                    maxLength="1"
                                    onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
                                />

                            ))}
                        </div>
                        <div className="max-w-[520px] w-full mx-auto mt-10 ">
                            <button type="button"
                                onClick={handleSubmit}
                                className="h-auto py-3 px-3 sm:h-14 md:h-[66px] bg-blue w-full text-center text-white font-semibold text-lg sm:text-2xl rounded-xl mb-5 sm:mb-[30px]">Confirm</button>
                        </div>
                    </div>

                </div>
            </div>

        </>
    )
};

export default AddPracticeReviews;
